import { Component, Input, OnInit, SimpleChanges,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal,NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CreatejobComponent } from '../createjob/createjob.component';
import { JobpropertiesComponent } from '../jobproperties/jobproperties.component';
import { CommonService } from '../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { W700servicesService } from '../services/w700services.service';
import { NewauditComponent } from '../newaudit/newaudit.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-w700jobslist',
  templateUrl: './w700jobslist.component.html',
  styleUrls: ['./w700jobslist.component.scss']
})

export class W700jobslistComponent implements OnInit, OnDestroy {
  private savePropertiesEventSubscription: Subscription;

  screenHeight: number;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: CommonService,
    private w700service: W700servicesService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private activeModal: NgbActiveModal
  ) { }
  classw700: string = '';
  deploymentkey: string = '';
  searchText: string = '';
  usernamedisplay: string;
  userrole: string = '';
  jobNames: string[] = []; 
  isDeployement: string = "";
  pagerolepermisions: any = '';
  keywordsearch_deployment ="name";

  deployemntlist: any = [];
  private static readonly displayFrequency: { [key: string]: string } = {
    'Seconds': 'S',
    'Minutes': 'M',
    'Hours': 'H',
    'Daily': 'D'
  };

  ngOnInit() {
    this.screenHeight = window.innerHeight - 229;
    this.getdeploymentconfiguration();
    this.savePropertiesEventSubscription = this.w700service.savePropertiesEvent.subscribe(
      (data: string) => {
        this.onKeyUpSearchJobslist(data);
        window.location.reload();

      }
    );
    // this.classw700 = 'mat-list-item ng-star-inserted active';
    // if (await this.service.checksession() == true) {
    //   var rolepermissinslist = JSON.parse(sessionStorage.getItem('rolepermissions'));
    //   this.pagerolepermisions = rolepermissinslist.filter(c => c.module == 'w700')[0];
    // }

    // if (this.router.url.includes("w700jobslist")) {
    //   this.classw700 = 'mat-list-item ng-star-inserted active';
    // }
    // else {
    //   this.classw700 = '';
    // }

    // if (await this.service.checksession() == true) {
    //   this.usernamedisplay = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['FormattedDisplayName'];
    //   this.userrole = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['role'];
    //   var rolepermissinslist = JSON.parse(sessionStorage.getItem('rolepermissions'));
    //   this.pagerolepermisions = rolepermissinslist.filter(c => c.module == 'w700')[0];
    //   if (this.pagerolepermisions != undefined) {
    //     this.route.queryParams.subscribe(
    //       params => {
    //         this.deploymentkey = params['deploymentkey'];
    //       }
    //     )
    //   }
    // }
  }

  ngOnDestroy() {
    if (this.savePropertiesEventSubscription) {
      this.savePropertiesEventSubscription.unsubscribe();
    }
  }

  getdeploymentconfiguration() {
    this.service.getDeployments("Deployments").subscribe(
      data => {
        if (data.length > 0) {
          this.deployemntlist= data;
        } else if (data.length === 0) {
          this.deployemntlist = [];
        }
    },error=>{
      this.ngxUiLoaderService.stop()
    })
  }

 
  isLoadingResult: boolean = false;
  ChangeDeployment(event) {
 
    if ( event !== "") {
      this.isDeployement = event.name
      //this.onKeyUpSearchJobslist(this.searchtext)
    }
  }

  searchDeplyoementCleared(){
    this.isDeployement ="";
    // this.w700jobslist =[];
    this.searchText ="";
  }

  onKeyUpSearchJobslist(event: any) {

    var val = event;
    this.searchtext = val;
    if (Number(val.length) + Number(1) > 2 || val ==='') {
      this.ngxUiLoaderService.start()
      this.w700jobslist=[]
      let deployement =  typeof(this.isDeployement)=="string"||typeof(this.isDeployement)==undefined? this.isDeployement:this.isDeployement['name'];
      // this.w700service.getapiurl("api/W700Jobs/GetW700ApplicationJobs?searchvalue=" + val, deployement).subscribe(response => {
      //   if (response['status'] && response['statusText']) {
      //   }
      //   else {
      //     this.ngxUiLoaderService.stop()
      //     this.w700jobslist = response as any[];
      //     if (this.w700jobslist.length > 0) {
      //       this.datashow = true;
      //     }
      //     else {
      //       this.datashow = false;
      //     }
      //   }
      // },error=>{
      //   this.ngxUiLoaderService.stop()
      // })
      var apiname = "api/VitalHubDXAPI/GetW700ApplicationJobs?searchvalue=" + val;
    
      this.w700service.getapi(apiname, deployement).subscribe({
        next: data => {
          this.w700jobslist = data as any[];
          this.jobNames = this.w700jobslist.map(job => job.JobName); 
          this.datashow = this.w700jobslist.length > 0;
          if(this.w700jobslist.length <= 0)
          {
            this.toastr.error( 'W700 Jobs Not Found ', "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          this.ngxUiLoaderService.stop();
        },
        error: error => {
          this.ngxUiLoaderService.stop();
        }
      });
    } else {
      this.w700jobslist = [];
      this.datashow = false;
    }
  }
  datashow: boolean = false;
  w700jobslist: any = [];

  // numbers = [];
  // noOfPages: number;
  // pageSize = 10;
  // currentPage = 0;
  // setPage(value) {
  //   this.currentPage = value;
  // }
  // setPagePrev() {
  //   if (this.currentPage != 0) {
  //     this.currentPage = this.currentPage - 1;
  //   }
  // }
  // setPageNext() {
  //   if (this.currentPage < this.noOfPages - 1) {
  //     this.currentPage = this.currentPage + 1;
  //   }
  // }

  public dataToModal: any;
  openCreateJobpopup(item) {
    
    this.dataToModal = {
      deploymentkey: typeof(this.isDeployement)=="string"||typeof(this.isDeployement)==undefined? this.isDeployement:this.isDeployement['name'],
      dataitem: {
        ...item,
        OperationValue: item.OperationValue === "" ? item.ClassName : item.OperationValue
      }
    }
    const modalRef = this.modalService.open(CreatejobComponent,
      { windowClass: "myCustomModalClasscreatejob", backdrop: 'static', keyboard: false, size: 'lg', });
    modalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
    // modalRef.result.then(() => {
    //    this.onKeyUpSearchJobslist(this.searchtext);
    // });
    modalRef.componentInstance.jobContent.subscribe((data: string) => {
    //  this.onKeyUpSearchJobslist(data);  
    this.activeModal.close(); 
  });
  }
  searchtext: string = '';

  openpropertiesJobpopup(item) {
    
    this.dataToModal = {
      deploymentkey: this.isDeployement,
      dataitem: item
    }
    const modalRef = this.modalService.open(JobpropertiesComponent,
      { windowClass: "myCustomModalClassProperties", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.inputDataInModalComponent = this.dataToModal;
    modalRef.componentInstance.jobPropertiesContent.subscribe((data: string) => {
        this.onKeyUpSearchJobslist(data);    
    });
  }
  onSearchJobs()
  {
    if (!this.isDeployement) {     
      this.toastr.warning('Deployment is Mandatory', '', { timeOut: 4000, positionClass: 'toast-bottom-right' });
      return; 
    }
  
    this.onKeyUpSearchJobslist(this.searchtext || '');
  }
  getstatus(spKey: boolean): string {
    return spKey === true ? 'Active' : 'Inactive';
  }

  getFrequency(frequencyType: string): string {
    if (frequencyType in W700jobslistComponent.displayFrequency) {
      return W700jobslistComponent.displayFrequency[frequencyType];
    }
    return frequencyType; 
  }


}
